import { runInAction } from 'mobx';

import client from './graphql.js';
import isServer from './is-server.js';

function getClientStores() {
  if (isServer) return {};

  window.__NEXT_MOBX_STORES__ ??= {};

  return window.__NEXT_MOBX_STORES__;
}

const clientStores = getClientStores();

export function toStoreName(Store) {
  const { storeName } = Store;

  return `${storeName[0].toLowerCase()}${storeName.slice(1)}Store`;
}

function refreshStore(store, storeContext) {
  runInAction(() => {
    Object.assign(store, storeContext);
    store.client = client(storeContext.token);
  });

  if (typeof store.onContextChange === 'function') store.onContextChange();
}

function getOrCreateClientStore(Store, storeContext) {
  const name = toStoreName(Store);

  if (!clientStores[name]) clientStores[name] = new Store(storeContext);

  return clientStores[name];
}

export function createStores(Stores, storeContext) {
  const entries = Stores.map((Store) => {
    const name = toStoreName(Store);

    if (isServer) return [name, new Store(storeContext)];

    const cachedStore = clientStores[name];

    if (!cachedStore) return [name, getOrCreateClientStore(Store, storeContext)];

    refreshStore(cachedStore, storeContext);

    return [name, cachedStore];
  });

  return Object.fromEntries(entries);
}

export function restoreStores(Stores, initialStores) {
  if (isServer) return initialStores;

  const entries = Stores.map((Store) => {
    const name = toStoreName(Store);

    return [name, getOrCreateClientStore(Store, initialStores[name])];
  });

  return Object.fromEntries(entries);
}
